import Button from 'components/gruenland/atoms/button/Button';
import CountryFlag from './CountryFlag';

type Props = {
  countryCode: string;
  onClick: () => void;
};
const CountryButton: React.FC<Props> = ({ countryCode, onClick }) => {
  return (
    <Button variant="buttonSecondary" onClick={onClick} size="xs" className="!px-4 !py-3">
      <CountryFlag countryCode={countryCode} />
    </Button>
  );
};
export default CountryButton;
